$(document).ready(function () {
  const slider = $(".slider");
  if (slider.length === 0) return;

  slider.unslider({
    autoplay: true,
    speed: 500,
    delay: 5000,
    keys: true,
    dots: true,
    fluid: true,
  });

  function trackMixpanelEvent(element, eventName) {
    if (!window.userAnalytics?.trackEvent) return;

    window.userAnalytics.trackEvent(eventName, {
      Category: element.attr("data-category"),
      Provider: "Reservamos",
      Page: $(".slider").attr("data-page"),
      Touchpoint: "Slider",
    });
  }

  $(".slider-link").each(function () {
    const linkEl = $(this);

    linkEl.on("click", function (event) {
      event.preventDefault();

      trackMixpanelEvent(linkEl, "Touchpoint Clicked");

      const url = linkEl.attr("href");
      const win = window.open(url, "_blank");
      if (win) win.focus();
    });
  });

  const unslider = slider.unslider();

  $(".unslider-arrow").on("click", function () {
    const fn = this.className.split(" ")[1];
    const instance = unslider.data("unslider");

    if (instance && typeof instance[fn] === "function") {
      instance[fn]();
    }
  });
});
